import { render, staticRenderFns } from "./TakePhoto.vue?vue&type=template&id=4343a9d6&scoped=true&"
import script from "./TakePhoto.vue?vue&type=script&lang=js&"
export * from "./TakePhoto.vue?vue&type=script&lang=js&"
import style0 from "./TakePhoto.vue?vue&type=style&index=0&id=4343a9d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4343a9d6",
  null
  
)

export default component.exports